import Card from './Card';
import CardTitle from './CardTitle';
import CardBodyGroup from './CardBodyGroup';
import CardBodyDivider from './CardBodyDivider';

export { CardTitle, CardBodyGroup, CardBodyDivider };

export default Card;
